<template>
  <div class="welcome-container">
    <div class="bg-decoration">
      <div class="circle circle-1"></div>
      <div class="circle circle-2"></div>
      <div class="circle circle-3"></div>
      <div class="circle circle-4"></div>
    </div>

    <div class="main-content">
      <div class="hero-section">
        <div class="hero-content">
          <div class="logo-wrapper">
            <div class="logo-ring"></div>
            <img src="../assets/artlens.jpg" alt="Art-Lens Logo" @click="handleLogoClick">
          </div>
          <h1 class="main-title">Art-Lens</h1>
          <p class="subtitle">阿特兰斯小程序内容管理系统</p>
          <p class="description">探索无限可能，成就研学梦想</p>
        </div>
      </div>

      <div class="features-section">
        <div class="feature-grid">
          <div class="feature-card" v-for="feature in features" :key="feature.path" @click="navigate(feature.path)">
            <div class="feature-icon" :style="{ background: feature.bgColor }">
              <i :class="feature.icon"></i>
            </div>
            <span class="feature-name">{{ feature.name }}</span>
            <span class="feature-desc">{{ feature.desc }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Welcome',
  data() {
    return {
      clickCount: 0,
      clickTimer: null,
      features: [
        { name: '订单列表', icon: 'el-icon-document', path: '/admin/orders', desc: '订单状态实时追踪', bgColor: 'linear-gradient(135deg, rgba(103, 194, 58, 0.15), rgba(103, 194, 58, 0.05))' },
        { name: '报名人管理', icon: 'el-icon-user', path: '/admin/enrolls', desc: '报名信息全面管理', bgColor: 'linear-gradient(135deg, rgba(230, 162, 60, 0.15), rgba(230, 162, 60, 0.05))' },
        { name: '活动管理', icon: 'el-icon-star-off', path: '/admin/activities', desc: '创建与管理研学活动', bgColor: 'linear-gradient(135deg, rgba(64, 158, 255, 0.15), rgba(64, 158, 255, 0.05))' },
        { name: '操作指南', icon: 'el-icon-s-promotion', path: '/admin/guide', desc: '系统使用方法与最佳实践', bgColor: 'linear-gradient(135deg, rgba(144, 147, 153, 0.15), rgba(144, 147, 153, 0.05))' },
      ]
    }
  },
  methods: {
    navigate(path) {
      this.$router.push(path);
    },
    handleLogoClick() {
      this.clickCount++;
      clearTimeout(this.clickTimer);
      
      this.clickTimer = setTimeout(() => {
        if (this.clickCount >= 3) {
          this.$router.push('/');
        }
        this.clickCount = 0;
      }, 1000);
    }
  }
}
</script>

<style scoped>
.welcome-container {
  min-height: 100vh;
  height: 100%;
  background: linear-gradient(135deg, #0a0f1a 0%, #131b2e 50%, #1e293b 100%);
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
}

.bg-decoration {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 0;
}

.circle {
  position: absolute;
  border-radius: 50%;
  opacity: 0.06;
  filter: blur(100px);
}

.circle-1 {
  width: 600px;
  height: 600px;
  background: linear-gradient(135deg, #409eff, #66b1ff);
  top: -150px;
  right: -100px;
}

.circle-2 {
  width: 500px;
  height: 500px;
  background: linear-gradient(135deg, #67c23a, #85ce61);
  bottom: -100px;
  left: -100px;
}

.circle-3 {
  width: 350px;
  height: 350px;
  background: linear-gradient(135deg, #e6a23c, #ebb563);
  top: 45%;
  right: 25%;
}

.circle-4 {
  width: 280px;
  height: 280px;
  background: linear-gradient(135deg, #d3adf7, #e5b8f4);
  bottom: 35%;
  right: 5%;
}

@media (prefers-reduced-motion: no-preference) {
  .circle-1 {
    animation: float 30s ease-in-out infinite;
  }
  .circle-2 {
    animation: float 25s ease-in-out infinite reverse;
  }
  .circle-3 {
    animation: float 28s ease-in-out infinite;
  }
  .circle-4 {
    animation: float 22s ease-in-out infinite reverse;
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-25px);
  }
}

.main-content {
  display: flex;
  height: 100vh;
  padding: 60px 80px;
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  width: 100%;
}

.hero-section {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.hero-content {
  text-align: center;
  color: #fff;
}

.logo-wrapper {
  margin-bottom: 40px;
  position: relative;
  display: inline-block;
}

.logo-ring {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 120px;
  height: 120px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.logo-wrapper img {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.08);
  padding: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  z-index: 1;
  background: rgba(255, 255, 255, 0.03);
}

.logo-wrapper img:hover {
  transform: scale(1.05);
  border-color: rgba(64, 158, 255, 0.25);
}

.main-title {
  font-size: 52px;
  font-weight: 800;
  margin-bottom: 16px;
  letter-spacing: 8px;
  background: linear-gradient(135deg, #ffffff, rgba(255, 255, 255, 0.85), rgba(255, 255, 255, 0.6));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: rgba(255, 255, 255, 0.9);
}

.subtitle {
  font-size: 22px;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 16px;
  font-weight: 300;
  letter-spacing: 10px;
}

.description {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.4);
  font-weight: 300;
  letter-spacing: 2px;
}

.features-section {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  width: 100%;
  max-width: 520px;
}

.feature-card {
  background: rgba(255, 255, 255, 0.02);
  border-radius: 18px;
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.03);
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(10px);
}

.feature-card:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.08);
  transform: translateY(-4px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);
}

.feature-icon {
  width: 60px;
  height: 60px;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.35s ease;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.feature-card:hover .feature-icon {
  transform: scale(1.1);
}

.feature-icon i {
  font-size: 28px;
  color: rgba(255, 255, 255, 0.95);
}

.feature-name {
  font-size: 16px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.95);
  letter-spacing: 0.5px;
}

.feature-desc {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.38);
  text-align: center;
  line-height: 1.5;
}

@media (max-width: 480px) {
  .main-content {
    flex-direction: column;
    height: auto;
    min-height: 100vh;
    padding: 30px 16px;
  }

  .hero-section {
    padding: 20px 0;
    margin-bottom: 10px;
  }

  .features-section {
    padding: 10px 0 30px;
  }

  .feature-grid {
    max-width: 100%;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }

  .feature-card {
    padding: 24px 14px;
    gap: 10px;
  }

  .feature-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
  }

  .feature-icon i {
    font-size: 22px;
  }

  .feature-name {
    font-size: 14px;
  }

  .feature-desc {
    font-size: 10px;
  }

  .main-title {
    font-size: 28px;
    letter-spacing: 3px;
  }

  .subtitle {
    font-size: 14px;
    letter-spacing: 4px;
  }

  .description {
    font-size: 11px;
  }

  .logo-wrapper img {
    width: 70px;
    height: 70px;
    padding: 5px;
  }

  .logo-ring {
    width: 65px;
    height: 65px;
  }

  .logo-wrapper {
    margin-bottom: 24px;
  }

  .circle-3,
  .circle-4 {
    display: none;
  }

  .circle-1,
  .circle-2 {
    animation: none;
  }

  .circle-1 {
    width: 350px;
    height: 350px;
    top: -80px;
    right: -80px;
  }

  .circle-2 {
    width: 300px;
    height: 300px;
    bottom: -60px;
    left: -60px;
  }
}
</style>